<ngx-smart-modal
  #importRunErrors
  class="run-errors-modal"
  identifier="importRunErrors"
  [closable]="true"
  [escapable]="false"
  [dismissible]="true"
  [showCloseButton]="showCloseButton"
  [showConfirmButton]="showConfirmButton"
  confirmButtonText="Proceed"
  [title]='title'>

  <h4 class="mb-3" style="line-height:2.5rem;" [innerHTML]="subTitle"></h4>

  <app-sample-sheet-errors [errors]="errors"></app-sample-sheet-errors>

</ngx-smart-modal>
